export const profileVisibility = {
  level: 'Standard',
  description: 'Standard',
  __typename: 'ProfileVisibility',
};

export const mockPublicVisibilityOption = {
  id: 'Public',
  name: 'Public',
  label: 'Public',
  description:
    'Anyone can view my profile. Employers can view and download my resumé and can also contact me directly or via SEEK.',
  __typename: 'PublicVisibilityOption' as const,
};

export const mockStandardVisibilityOption = {
  id: 'Standard',
  name: 'Standard',
  label: 'Standard',
  description:
    'Employers can view and download my resumé and can also contact me directly or via SEEK.',
  __typename: 'StandardVisibilityOption' as const,
};

export const mockLimitedVisibilityOption = {
  id: 'Limited',
  name: 'Limited',
  label: 'Limited',
  description: 'Employers can view my profile, but cannot contact me directly.',
  __typename: 'LimitedVisibilityOption' as const,
};

export const mockHiddenVisibilityOption = {
  id: 'Hidden',
  name: 'Hidden',
  label: 'Hidden',
  description: 'Employers cannot search for me.',
  __typename: 'HiddenVisibilityOption' as const,
};

export const mockProfileVisibilityOptions = [
  mockPublicVisibilityOption,
  mockStandardVisibilityOption,
  mockLimitedVisibilityOption,
  mockHiddenVisibilityOption,
];

export const profileVisibility2 = mockStandardVisibilityOption;

export const approachability = {
  __typename: 'Approachability',
  approachable: true,
};
